import React from "react";
import { useLang } from "@/i18n/LanguageContext";

const ABOUT_IMG = "https://images.unsplash.com/photo-1721244654394-36a7bc2da288?w=1200&q=80";

const About = () => {
  const { t } = useLang();
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-36">
      <div className="container-page">
        <div className="flex items-center gap-3 text-xs font-mono uppercase tracking-[0.18em] text-neutral-500 mb-10">
          <span className="w-8 h-px bg-neutral-400" />
          {t.about.eyebrow}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-7">
            <h2 data-testid="about-title" className="font-display text-4xl md:text-6xl leading-[1.02] tracking-tight text-black">
              {t.about.title}
            </h2>
            <p data-testid="about-body" className="mt-8 max-w-2xl text-lg text-neutral-600 leading-relaxed">
              {t.about.body}
            </p>
          </div>
          <div className="lg:col-span-5">
            <div className="relative aspect-[4/5] overflow-hidden bg-neutral-200">
              <img src={ABOUT_IMG} alt="Blueprint" className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/70 to-transparent text-white font-mono text-[10px] uppercase tracking-[0.2em]">
                Plan 04 · Sheet A-201
              </div>
            </div>
          </div>
        </div>

        {/* Values */}
        <div className="mt-24 border-t border-[var(--border)] grid grid-cols-1 md:grid-cols-3">
          {t.about.values.map((v, i) => (
            <div
              key={v.num}
              data-testid={`about-value-${i}`}
              className={`p-8 md:p-10 ${i > 0 ? "md:border-l border-[var(--border)]" : ""} border-t md:border-t-0 ${i > 0 ? "border-t" : "border-t-0 md:border-t-0"}`}
            >
              <div className="font-mono text-xs text-neutral-500">{v.num}</div>
              <div className="mt-6 font-display text-3xl text-black">{v.title}</div>
              <p className="mt-3 text-neutral-600 leading-relaxed">{v.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
